module.exports = __webpack_public_path__ + "static/media/Step7.82d0e193.png";